var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWwcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.38,14.26L26,26.15l-9.87-5.77c-3.51-2.04-7.01-4.09-10.52-6.14c0.04-0.49,0.31-0.95,0.74-1.2L25.26,2.02 c0.46-0.28,1.04-0.28,1.51,0l18.87,11.02C46.07,13.3,46.35,13.76,46.38,14.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.47,25.59l-3.93,9.47l1.39,0.8l0.96-2.51l4.28,2.47l0.96,3.63l1.38,0.79l-3.87-13.97L14.47,25.59z  M13.3,32.32l1.75-4.48l1.72,6.48L13.3,32.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.39,37.66c0,0.53-0.29,1.03-0.74,1.3l-18.9,11.02c-0.08,0.05-0.16,0.09-0.25,0.12V27.02l19.88-11.6 L46.39,37.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.38,14.34c0-0.88-0.47-1.71-1.24-2.16L27.28,1.16c-0.78-0.47-1.75-0.47-2.53,0L5.85,12.18 c-0.77,0.45-1.24,1.28-1.24,2.16v23.32c0,0.88,0.47,1.71,1.24,2.16l18.88,11.02c0.38,0.23,0.82,0.35,1.27,0.35s0.89-0.12,1.26-0.35 l18.89-11.02c0.77-0.45,1.24-1.28,1.24-2.16l-0.01-23.11V14.34z M18.13,39.45l-0.96-3.63l-4.28-2.47l-0.96,2.51l-1.39-0.8 l3.93-9.47l1.17,0.68l3.87,13.97L18.13,39.45z M16.13,20.38c-3.51-2.04-7.01-4.09-10.52-6.14c0.04-0.49,0.31-0.95,0.74-1.2 L25.26,2.02c0.46-0.28,1.04-0.28,1.51,0l18.87,11.02c0.43,0.26,0.71,0.72,0.74,1.22L26,26.15L16.13,20.38z M45.65,38.96 l-18.9,11.02c-0.08,0.05-0.16,0.09-0.25,0.12V27.02l19.88-11.6l0.01,22.24C46.39,38.19,46.1,38.69,45.65,38.96z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "13.3,32.32 16.77,34.32 15.05,27.84  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.12,30.18c0.47-0.5,0.84-1.03,1.11-1.61c0.27-0.58,0.4-1.15,0.4-1.7c0-1.03-0.29-1.64-0.85-1.84 s-1.39,0.01-2.5,0.65l-3.33,1.92l0.03,11.73l3.54-2.05c1.09-0.62,1.92-1.41,2.51-2.35c0.59-0.95,0.89-1.94,0.89-2.99 c-0.01-0.69-0.17-1.19-0.49-1.5C39.11,30.13,38.67,30.04,38.12,30.18z M34.29,28.09l2-1.15c0.67-0.38,1.16-0.52,1.49-0.42 c0.33,0.1,0.49,0.48,0.5,1.12c0,0.59-0.18,1.15-0.53,1.69c-0.35,0.54-0.82,0.99-1.41,1.33l-2.04,1.17L34.29,28.09z M38.02,34.59 c-0.36,0.58-0.85,1.06-1.48,1.42l-2.22,1.28l-0.01-4.22l2.24-1.3c1.34-0.77,2.01-0.45,2.01,0.96 C38.56,33.39,38.38,34.01,38.02,34.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.23,9.96c-0.82-0.47-1.74-0.78-2.73-0.91c-1.01-0.14-2.03-0.1-3.08,0.12c-1.06,0.22-2.05,0.6-2.99,1.15 l-0.98,0.57c-1.44,0.84-2.23,1.71-2.36,2.63c-0.13,0.92,0.41,1.72,1.61,2.42c1.11,0.64,2.29,0.99,3.55,1.03 c1.25,0.05,2.48-0.2,3.67-0.75l-1.35-0.78c-0.97,0.41-1.82,0.6-2.56,0.56c-0.74-0.04-1.48-0.27-2.23-0.7 c-0.83-0.48-1.15-1.04-0.96-1.69c0.19-0.65,0.83-1.29,1.93-1.93l0.98-0.57c1.17-0.68,2.31-1.06,3.43-1.14 c1.12-0.08,2.11,0.12,2.97,0.62c0.7,0.4,1.06,0.82,1.09,1.26c0.03,0.43-0.31,0.92-1,1.46l1.35,0.78c0.96-0.68,1.41-1.38,1.35-2.11 C32.89,11.26,32.32,10.58,31.23,9.96z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwcc);
export default __webpack_public_path__ + "static/media/wwcc.c5be691dee1c123d91fd3bce9e6497d7.svg";
export { ForwardRef as ReactComponent };